(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["apx-research-disclaimer"] && !Shopify.designMode) return;
  try {
    (function () {
    var storageKey = 'apx_vital_research_disclaimer_v1';
    var storageDays = 30;
    var gate = document.getElementById('apx-research-gate');
    var agreeButton = document.getElementById('apx-research-agree');
    var disagreeButton = document.getElementById('apx-research-disagree');
    var errorMessage = document.getElementById('apx-research-error');

    if (!gate || !agreeButton || !disagreeButton || !errorMessage) {
      return;
    }

    function hasAgreement() {
      try {
        var savedValue = localStorage.getItem(storageKey);

        if (!savedValue) {
          return false;
        }

        var savedData = JSON.parse(savedValue);

        if (!savedData.expiry || Date.now() > savedData.expiry) {
          localStorage.removeItem(storageKey);
          return false;
        }

        return savedData.agreed === true;
      } catch (error) {
        return document.cookie.indexOf(storageKey + '=true') !== -1;
      }
    }

    function saveAgreement() {
      var expiryTime = Date.now() + storageDays * 24 * 60 * 60 * 1000;

      try {
        localStorage.setItem(
          storageKey,
          JSON.stringify({
            agreed: true,
            expiry: expiryTime
          })
        );
      } catch (error) {
        document.cookie =
          storageKey +
          '=true; max-age=' +
          storageDays * 24 * 60 * 60 +
          '; path=/; SameSite=Lax';
      }
    }

    function closeGate() {
      gate.hidden = true;
      document.body.classList.remove('apx-research-gate-open');
    }

    if (hasAgreement()) {
      closeGate();
      return;
    }

    document.body.classList.add('apx-research-gate-open');
    window.setTimeout(function () {
      agreeButton.focus();
    }, 50);

    agreeButton.addEventListener('click', function () {
      saveAgreement();
      closeGate();
    });

    disagreeButton.addEventListener('click', function () {
      errorMessage.hidden = false;
      errorMessage.focus();
    });

    gate.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
      }

      if (event.key !== 'Tab') {
        return;
      }

      var focusableElements = gate.querySelectorAll('a[href], button:not([disabled])');

      if (!focusableElements.length) {
        return;
      }

      var firstElement = focusableElements[0];
      var lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
